// getMessageDrmMediaSource.js
'use strict';
import { Collection } from 'immutable';

import { FEATURE_APPEND_CLEARKEY_TO_MANIFEST_URL } from '../RemoteConfigKeys.js';

import createCachedSelector from '../resource/createCachedSelector.js';
import {
  getAssetManifest,
  getAssetTrailer,
  MediaAssetFormat,
  MediaPreset,
} from '../resource/getMediaAsset.js';
import { getMessageMediaViewState } from '../selector/getMessageData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

/**
 * Select drm media source by
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} messageId - message id.
 * @param {string} assetId - message asset id.
 * @param {string} dataKey - data key.
 * @return {any} The selected drm media source.
 */
const getMessageDrmMediaSource = createCachedSelector(
  (state, messageId) => messageId,
  (state, messageId, assetId) => assetId,
  (state, messageId, assetId, dataKey) => dataKey,
  (state, messageId) => getMessageMediaViewState(state, messageId),
  state => getRemoteConfigData(state, FEATURE_APPEND_CLEARKEY_TO_MANIFEST_URL),
  (
    messageId,
    assetId,
    dataKey,
    { canViewClearMedia, canViewClearTrailer },
    shouldAppendClearkeyToManifestUrl
  ) => {
    let result = undefined;
    if ('drmMediaSource' === dataKey) {
      result = {
        dash: getAssetManifest({
          id: messageId,
          assetId,
          format: MediaAssetFormat.MPD,
          preset: canViewClearMedia ? MediaPreset.SD : MediaPreset.SD_PREVIEW,
          shouldAppendClearkeyToManifestUrl,
        }).href,
        hls: getAssetManifest({
          id: messageId,
          assetId,
          format: MediaAssetFormat.M3U8,
          preset: canViewClearMedia ? MediaPreset.SD : MediaPreset.SD_PREVIEW,
        }).href,
        mp4: getAssetTrailer({
          id: messageId,
          assetId,
          format: MediaAssetFormat.MP4,
          preset: canViewClearTrailer ? MediaPreset.SD : MediaPreset.SD_PREVIEW,
        }).href,
      };
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)(
  (state, messageId, assetId, dataKey) =>
    `getMessageDrmMediaSource:${messageId}:${assetId}:${dataKey}`
);

export default getMessageDrmMediaSource;
